import { render, staticRenderFns } from "./SaveConfiguration.vue?vue&type=template&id=7450a46c"
import script from "./SaveConfiguration.vue?vue&type=script&lang=js"
export * from "./SaveConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SaveConfiguration.vue?vue&type=style&index=0&id=7450a46c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports